import React, { memo } from "react";
import { SvgIcon } from "@mui/material";
import { IIconProps } from "@/models";

const Mp4Icon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 32 32"
      sx={{ fontSize: "inherit", ...sx }}
      {...otherProps}
    >
      <path
        d="M20.0231 2.875C20.2147 2.87447 20.4045 2.91196 20.5815 2.98529C20.7586 3.05861 20.9193 3.16633 21.0544 3.30219L26.6875 8.93531C26.8233 9.07043 26.931 9.23114 27.0044 9.40815C27.0777 9.58517 27.1152 9.77496 27.1147 9.96656V27.6666C27.1147 28.4709 26.4538 29.125 25.6416 29.125H6.34812C5.53562 29.125 4.875 28.4709 4.875 27.6666V4.33344C4.875 3.52906 5.53594 2.875 6.34812 2.875H20.0231ZM20.0231 2H6.34812C5.05125 2 4 3.04469 4 4.33344V27.6666C4 28.9553 5.05125 30 6.34812 30H25.6416C26.9384 30 27.9897 28.9553 27.9897 27.6666V9.96656C27.9896 9.34771 27.7438 8.75421 27.3062 8.31656L21.6731 2.68344C21.2355 2.24592 20.642 2.0001 20.0231 2Z"
        fill="currentColor"
      />
      <path
        d="M20 2V7.33344C20.0001 8.04063 20.281 8.71883 20.7811 9.21889C21.2812 9.71895 21.9594 9.99992 22.6666 10H28L20 2Z"
        fill="currentColor"
      />
      <path
        d="M18.9651 26.4733V25.7716L20.7244 23H21.3293V23.9712H20.9713L19.8622 25.7264V25.7593H22.3622V26.4733H18.9651ZM20.9877 27.214V26.2593L21.0042 25.9486V23H21.8396V27.214H20.9877Z"
        fill="currentColor"
      />
      <path
        d="M15.302 27.214V23H16.9646C17.2842 23 17.5565 23.061 17.7814 23.1831C18.0064 23.3038 18.1779 23.4719 18.2959 23.6872C18.4152 23.9012 18.4749 24.1482 18.4749 24.428C18.4749 24.7078 18.4145 24.9547 18.2938 25.1687C18.1731 25.3827 17.9982 25.5494 17.7691 25.6687C17.5414 25.7881 17.2657 25.8478 16.9419 25.8478H15.8823V25.1338H16.7979C16.9694 25.1338 17.1107 25.1043 17.2218 25.0453C17.3343 24.9849 17.4179 24.9019 17.4728 24.7963C17.529 24.6893 17.5572 24.5665 17.5572 24.428C17.5572 24.2881 17.529 24.166 17.4728 24.0617C17.4179 23.9561 17.3343 23.8745 17.2218 23.8169C17.1093 23.7579 16.9666 23.7284 16.7938 23.7284H16.193V27.214H15.302Z"
        fill="currentColor"
      />
      <path
        d="M10 23H11.0988L12.2593 25.8313H12.3087L13.4692 23H14.5679V27.214H13.7037V24.4712H13.6688L12.5782 27.1934H11.9897L10.8992 24.4609H10.8642V27.214H10V23Z"
        fill="currentColor"
      />
      <path
        d="M13 15V12.384C13 11.7685 13.666 11.3836 14.1993 11.6908L16.4722 13L18.7651 14.3102C19.3007 14.6162 19.303 15.3877 18.7692 15.697L16.4722 17.0278L14.1993 18.337C13.666 18.6442 13 18.2592 13 17.6438V15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(Mp4Icon);
